import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Full-screen PDF viewer page. Opens in a new tab so the browser tab shows
 * the site favicon (from our HTML) instead of the default PDF icon.
 */
export const PdfViewerPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const file = searchParams.get("file");

  useEffect(() => {
    document.title = file ? "PDF - Croma Ply" : "PDF - Croma Ply";
  }, [file]);

  if (!file) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <p className="text-gray-600">No PDF specified.</p>
      </div>
    );
  }

  const decodedUrl = decodeURIComponent(file);

  return (
    <div className="fixed inset-0 w-full h-full bg-gray-100" style={{ margin: 0, padding: 0 }}>
      <iframe
        title="PDF"
        src={decodedUrl}
        className="w-full h-full border-0"
        style={{ display: "block" }}
      />
    </div>
  );
};
